<template>
  <div>
    <PaymentCalculatorDetail class="cyLeaseTotalVehiclePrice" :details="totalVehiclePriceDetails">
    </PaymentCalculatorDetail>
    <PaymentCalculatorDetail class="cyLeasePaymentDetails" :details="leaseDetails"> </PaymentCalculatorDetail>
    <PaymentCalculatorDetail
      class="cyDueOnDelivery"
      :heading="$t('message.eCommerceV2.paymentCalculator.dueOnDelivery')"
      :details="dueOnDeliveryDetails"
    >
    </PaymentCalculatorDetail>
    <PaymentCalculatorDetail class="lead font-weight-bold text-dark cyLeasePayment" :details="paymentDetails">
    </PaymentCalculatorDetail>
    <tool-tip id="amountLeasedTooltip" :title="amountLeasedTooltipTitle" :body="amountLeasedTooltipBody"></tool-tip>
    <tool-tip id="residualValueTooltip" :title="residualValueTooltipTitle" :body="residualValueTooltipBody"></tool-tip>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PaymentCalculatorDetail from '@/components/shared/payment-calculator/PaymentCalculatorDetail.vue';
import ToolTip from '@/components/ToolTip.vue';

export default {
  name: 'PaymentDetailsLease',
  components: {
    PaymentCalculatorDetail,
    ToolTip,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('paymentCalculator', ['lease', 'downPayment', 'paymentPeriod', 'leasePaymentTerm']),
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
      taxRate: 'paymentCalculator/taxRate',
    }),
    amountLeasedTooltipTitle() {
      return this.$t('message.eCommerceV2.paymentCalculator.amountToBeLeased');
    },
    amountLeasedTooltipBody() {
      return this.$t('message.eCommerceV2.paymentCalculator.amountToBeLeasedTooltip');
    },
    residualValueTooltipTitle() {
      return this.$t('message.eCommerceV2.paymentCalculator.residualValue');
    },
    residualValueTooltipBody() {
      return this.$t('message.eCommerceV2.paymentCalculator.residualValueTooltip');
    },
    totalVehiclePriceDetails() {
      return [
        {
          name: this.$t('message.eCommerceV2.paymentCalculator.totalVehiclePrice'),
          value: this.$n(this.lease.preTaxVehiclePrice, 'currency', this.languageCode),
        },
      ];
    },
    leaseDetails() {
      return [
        {
          name: `${this.$t('message.eCommerceV2.paymentCalculator.amountToBeLeased')}`,
          value: this.$n(this.lease.leaseAmount, 'currency', this.languageCode),
          tooltipIcon: ['far', 'info-circle'],
          tooltipId: 'amountLeasedTooltip',
        },
        {
          name: `${this.$t('message.eCommerceV2.paymentCalculator.residualValue')}`,
          value: this.$n(this.lease.residualValue, 'currency', this.languageCode),
          tooltipIcon: ['far', 'info-circle'],
          tooltipId: 'residualValueTooltip',
        },
        {
          name: this.$t('message.eCommerceV2.paymentCalculator.leaseTerm'),
          value: `${this.leasePaymentTerm} ${this.$t('message.eCommerceV2.paymentCalculator.months')}`,
        },
        {
          name: `${this.$t(`message.eCommerceV2.paymentCalculator.${this.paymentPeriod}`)} ${this.$t(
            'message.eCommerceV2.paymentCalculator.paymentIncludingTax'
          )}`,
          value: this.$n(this.lease.paymentAmount, 'currency', this.languageCode),
        },
      ];
    },
    dueOnDeliveryDetails() {
      const details = [
        {
          name: this.$t('message.eCommerceV2.paymentCalculator.firstPayment'),
          value: this.$n(this.lease.paymentAmount, 'currency', this.languageCode),
        },
        {
          name: this.$t('message.eCommerceV2.paymentCalculator.subtotal'),
          value: this.$n(this.lease.dueOnDelivery, 'currency', this.languageCode),
        },
      ];
      if (this.downPayment && this.downPayment !== '0') {
        details.unshift(
          {
            name: this.$t('message.eCommerceV2.paymentCalculator.downPayment'),
            value: this.$n(this.downPayment, 'currency', this.languageCode),
          },
          {
            name: this.$t('message.eCommerceV2.paymentCalculator.tax'),
            value: this.$n(this.lease.downPaymentTax, 'currency', this.languageCode),
          }
        );
      }
      return details;
    },
    paymentDetails() {
      return [
        {
          name: `${this.$t(`message.eCommerceV2.paymentCalculator.${this.paymentPeriod}`)} ${this.$t(
            'message.eCommerceV2.paymentCalculator.payment'
          )}`,
          value: this.$n(this.lease.paymentAmount, 'currency', this.languageCode),
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>
